import { render, staticRenderFns } from "./UiShowTicketsForm.vue?vue&type=template&id=3aa1e672&lang=pug&"
import script from "./UiShowTicketsForm.vue?vue&type=script&lang=js&"
export * from "./UiShowTicketsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports